import React from "react";

function WebsiteTerms() {

  return (
    <div className="privacy-page-section">
    <div className="heading-banner-page">
      <div className="container">
        <h1>Terms & Conditions</h1>
        <nav aria-label="breadcrumb">
        <ol className="breadcrumb justify-content-center">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active" aria-current="page">Terms & Conditions</li>
        </ol>
      </nav>
    </div>
  </div>
  <div className="innerpage-padding">
    <div className="container">
      <div className="cms-content">
        <h3>Introduction</h3>
        <p>Welcome to MedConnect. These Terms & Conditions govern your access and use of our online doctor consultation platform. By using our services, you agree to comply with and be bound by these terms. If you do not agree, please refrain from using our services.</p>
        
        <h3>Acceptance of Terms</h3>
        <p>By accessing and using MedConnect, you acknowledge that you have read, understood, and agreed to these Terms & Conditions. Our platform provides telemedicine services, connecting patients with healthcare professionals for consultations, prescriptions, and medical advice.</p>
        
        <h5>01 Use of Services</h5>
        <p>MedConnect facilitates virtual consultations with certified medical professionals. However, it does not replace in-person medical examinations when necessary. Users must provide accurate and complete medical information during consultations.</p>
        
        <h5>02 Patient Responsibilities</h5>
        <p>Users must ensure that all information provided is truthful and up to date. MedConnect is not responsible for misdiagnosis due to incorrect or incomplete information shared by the patient.</p>
        
        <h5>03 Privacy and Data Protection</h5>
        <p>We are committed to protecting your personal and medical data. All consultations and records are securely stored and handled in compliance with data protection laws.</p>
        
        <h5>04 Payment and Refund Policy</h5>
        <p>Fees for consultations are displayed before booking an appointment. Payments are processed securely, and refunds are only applicable under specific conditions outlined in our refund policy.</p>
        
        <h5>05 Limitation of Liability</h5>
        <p>MedConnect and its healthcare providers are not liable for any direct, indirect, or incidental damages arising from the use of our platform. Users are encouraged to seek emergency care in life-threatening situations.</p>
        
        <h5>06 Amendments to Terms</h5>
        <p>We reserve the right to modify these Terms & Conditions at any time. Continued use of the platform after changes are posted implies acceptance of the revised terms.</p>
      </div>
    </div>
  </div>
</div>
  );
}

export default WebsiteTerms;